import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoresAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { STORES_SLICE_NAME } from './models';
import { IGetStoresDTO, IStoreResponse } from '@/models/stores.model';

export const getStores = createAsyncThunk<IStoreResponse, IGetStoresDTO, { serializedErrorType: IApiError }>(
  `${STORES_SLICE_NAME}/getStores`,
  async (data) => {
    const response = await StoresAPI.getStores(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
